import { noop } from '@kofno/piper';
import { fromNullable, Maybe } from 'maybeasy';
import { err, ok, Result } from 'resulty';
import { Task } from 'taskarian';

export interface MissingVarError {
  kind: 'missing-var-error';
  key: string;
}

export const missingVarError = (key: string): MissingVarError => ({
  kind: 'missing-var-error',
  key,
});

export const readVarM = (key: string): Maybe<string> => {
  return fromNullable(import.meta.env[key]);
};

export const readVarR = (key: string): Result<MissingVarError, string> =>
  readVarM(key).cata({
    Just: (v) => ok(v),
    Nothing: () => err(missingVarError(key)),
  });

export const readVarT = (key: string): Task<MissingVarError, string> =>
  new Task((reject, resolve) => {
    readVarR(key).cata({
      Ok: resolve,
      Err: reject,
    });
    return noop;
  });
